import { render, staticRenderFns } from "./message-compose-direct.vue?vue&type=template&id=e4ec4576&scoped=true"
import script from "./message-compose-direct.vue?vue&type=script&lang=js"
export * from "./message-compose-direct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ec4576",
  null
  
)

export default component.exports